import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import React from "react";
import Grid from "@material-ui/core/Grid";
import {
	IconButton,
	PrimaryButton,
	SecondaryButton
} from "@prestosports/commons-ui";
import Close32 from "@carbon/icons-react/lib/close/32";
import commonStyles from "../styles/Common.styles";

const RuleSetConfirmationDialog = ({
	restoreConfirmationOpen,
	confirmRestore,
	cancelRestore,
	ruleSetName
}) => {
	const commonClasses = commonStyles();

	return (
		<Dialog
			open={restoreConfirmationOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">
				Change rule set
				<IconButton
					onClick={cancelRestore}
					aria-label="close-dialog"
					className={commonClasses.closeButton}
				>
					<Close32 />
				</IconButton>
			</DialogTitle>
			<DialogContent dividers>
				<DialogContentText id="alert-dialog-description">
					Switch to the {ruleSetName} rule set? Settings you have changed are kept
					where {ruleSetName} has the same setting; everything else follows the new
					rule set.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Grid container direction="row" justifyContent="flex-end" spacing={2}>
					<Grid item>
						<SecondaryButton label="No" onClick={cancelRestore} size="medium" />
					</Grid>
					<Grid item>
						<PrimaryButton label="Yes" onClick={confirmRestore} size="medium" />
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	);
};

export default RuleSetConfirmationDialog;
